// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
  text-decoration: none;
}

body {
  background-color: transparent;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  margin: 0;
  text-shadow: 0.4px 0.2 black;
  background-color: #c2e2ea;
  margin: 5px 10px;
}

h1, h2, h3, li, input {
  color: #002d67;
}

h1 {
  font-size: 1.4rem;
}

h3 {
  font-size: 1rem;
}

li, input, a, .copyRights {
  border-radius: 0.15rem;
  font-size: 0.7rem;
}

header {
  margin-top: 2rem;
}

section {
  margin-top: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  gap: 0.4rem;
  white-space: nowrap;
  font-size: 0.8rem;
}

.btn {
  transition: all 0.5s;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #002d67;
  background-color: #c2e2ea !important;
  border: 2px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  cursor: pointer;
  text-align: center;
}
.btn:active {
  transform: scale(0.98);
}
.btn:focus {
  outline: 0;
}

.Side, form {
  flex: 1;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem 0.2rem;
  background: #72bbce;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1);
  border-radius: 0.2rem;
  height: 80vh;
  width: 40vw;
}
.Side .btn, form .btn {
  align-self: flex-end;
}

.Side {
  overflow: scroll;
}

.fstSect {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.recentScores {
  background: #72bbce;
  gap: 0.2rem;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
  align-items: stretch;
}
.recentScores li {
  border: 1px black solid;
  text-align: left;
  padding: 0.2rem;
}

input {
  padding: 0.2rem;
}

footer {
  position: relative;
  margin-top: 2rem;
  top: 0;
  bottom: 0.1rem;
}

@media (min-width: 768px) {
  body {
    font-size: 18px;
    padding-left: calc(12% - 80px);
    padding-right: calc(12% - 80px);
  }
  section {
    gap: 2rem;
    padding-left: calc(25% - 120px);
    padding-right: calc(25% - 120px);
  }
}
@media (min-width: 999px) {
  body {
    font-size: 23px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Sass/main.sass","webpack://./src/styles/Sass/global.sass"],"names":[],"mappings":"AAGA;EACI,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;AADJ;;AAGA;EACI,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,SAAA;EACA,4BAAA;EACA,yBChBY;EDiBZ,gBAAA;AAAJ;;AAEA;EACI,cClBQ;ADmBZ;;AACA;EACI,iBAAA;AAEJ;;AAAA;EACI,eAAA;AAGJ;;AADA;EACI,sBAAA;EACA,iBAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,gBAAA;ECtBA,aAAA;EACA,mBAAA;EDuBA,8BAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAOJ;;AALA;EC1BI,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cApBQ;EAqBR,oCAAA;EACA,WAAA;EACA,wEAtBS;EAuBT,YAAA;EACA,eAAA;EACA,kBAAA;ADmCJ;ACjCI;EACI,sBAAA;ADmCR;ACjCI;EACI,UAAA;ADmCR;;AAtBA;EACI,OAAA;EACA,WAAA;ECvCA,aAAA;EACA,sBAAA;EDwCA,uBAAA;EACA,sBAAA;EACA,mBCpDc;EDqDd,wECnDS;EDoDT,qBAAA;EACA,YAAA;EACA,WAAA;AA0BJ;AAxBI;EACI,oBAAA;AA0BR;;AAxBA;EACI,gBAAA;AA2BJ;;AAzBA;ECnDI,aAAA;EACA,mBAAA;EDoDA,8BAAA;EACA,mBAAA;EACA,WAAA;AA6BJ;;AA3BA;EACI,mBCvEc;EDwEd,WAAA;EC/DA,aAAA;EACA,sBAAA;EDgEA,gBAAA;EACA,uBAAA;EACA,oBAAA;AA+BJ;AA7BI;EACI,uBAAA;EACA,gBAAA;EACA,eAAA;AA+BR;;AA7BA;EACI,eAAA;AAgCJ;;AA9BA;EACI,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,cAAA;AAiCJ;;AA/BA;EACI;IACI,eAAA;IACA,8BC1FI;ID2FJ,+BC7FI;ED+HV;EAhCE;IACI,SAAA;IACA,+BC9FI;ID+FJ,gCCjGI;EDmIV;AACF;AAlCA;EACI;IACI,eAAA;EAoCN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap')\r\n@import global\r\n\r\n*\r\n    box-sizing: border-box\r\n    margin: 0\r\n    padding: 0\r\n    list-style: none\r\n    outline: none\r\n    text-decoration: none\r\n\r\nbody\r\n    background-color: transparent\r\n    font-family: 'Roboto', sans-serif\r\n    font-size: 12px\r\n    margin: 0\r\n    text-shadow: 0.4px .2 black\r\n    background-color: $primary-color\r\n    margin: 5px 10px\r\n\r\nh1, h2, h3,li, input\r\n    color: $fontColor\r\n\r\nh1\r\n    font-size: 1.4rem\r\n\r\nh3\r\n    font-size: 1rem\r\n\r\nli, input, a, .copyRights\r\n    border-radius: .15rem\r\n    font-size: .7rem\r\n\r\nheader\r\n    margin-top: 2rem\r\n\r\nsection\r\n    margin-top: 2rem\r\n    @include rowFlex\r\n    justify-content: space-between\r\n    align-items: stretch\r\n    gap: .4rem\r\n    white-space: nowrap\r\n    font-size: .8rem\r\n\r\n.btn\r\n    @include button\r\n\r\n.Side, form\r\n    flex: 1\r\n    gap: .5rem\r\n    @include columnFlex\r\n    justify-content: center\r\n    padding: .5rem .2rem\r\n    background: $secondary-color\r\n    box-shadow: $box-shadow\r\n    border-radius: .2rem\r\n    height: 80vh\r\n    width: 40vw\r\n\r\n    .btn\r\n        align-self: flex-end\r\n\r\n.Side\r\n    overflow: scroll\r\n\r\n.fstSect\r\n    @include rowFlex\r\n    justify-content: space-between\r\n    align-items: center\r\n    gap: .5rem\r\n\r\n.recentScores\r\n    background: $secondary-color\r\n    gap: .2rem\r\n    @include columnFlex\r\n    text-align: left\r\n    justify-content: center\r\n    align-items: stretch\r\n\r\n    li\r\n        border: 1px black solid\r\n        text-align: left\r\n        padding: .2rem\r\n\r\ninput\r\n    padding: .2rem\r\n\r\nfooter\r\n    position: relative\r\n    margin-top: 2rem\r\n    top: 0\r\n    bottom: 0.1rem\r\n\r\n@media ( min-width: 768px  )\r\n    body\r\n        font-size: 18px\r\n        padding-left: $qlpadding\r\n        padding-right: $qrpadding\r\n\r\n    section\r\n        gap: 2rem\r\n        padding-left: $Qlpadding\r\n        padding-right: $Qrpadding\r\n@media ( min-width: 999px  )\r\n    body\r\n        font-size: 23px\r\n","$InterFont: \"Inter\", sans-serif\r\n$primary-color: #c2e2ea\r\n$secondary-color: #72bbce\r\n$fontColor: #002d67\r\n$box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1)\r\n$qrpadding: calc( 12% - 80px )\r\n$Qrpadding: calc( 25% - 120px )\r\n$qlpadding: calc( 12% - 80px )\r\n$Qlpadding: calc( 25% - 120px )\r\n\r\n@mixin columnFlex\r\n    display: flex\r\n    flex-direction: column\r\n\r\n@mixin rowFlex\r\n    display: flex\r\n    flex-direction: row\r\n\r\n@mixin button\r\n    transition: all 0.5s\r\n    border-radius: 4px\r\n    font-size: .9rem\r\n    font-weight: 600\r\n    color: $fontColor\r\n    background-color: $primary-color !important\r\n    border: 2px\r\n    box-shadow: $box-shadow\r\n    padding: 3px\r\n    cursor: pointer\r\n    text-align: center\r\n\r\n    &:active\r\n        transform: scale(0.98)\r\n\r\n    &:focus\r\n        outline: 0\r\n\r\n@mixin oneFiveGrid\r\n    display: grid\r\n    grid-template-columns: 1fr\r\n    grid-auto-rows: 1fr 1fr 1fr 1fr 1fr\r\n\r\n@mixin fiveOneGrid\r\n    display: grid\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr\r\n    grid-auto-rows: 1fr\r\n\r\n@mixin twoThreeGrid\r\n    display: grid\r\n    grid-template-columns: 1fr 1fr\r\n    grid-template-rows: 1fr 1fr 1fr\r\n\r\n@mixin globalFont\r\n    font-family: $InterFont\r\n    font-weight: 500\r\n    font-size: 1.2rem\r\n\r\n@mixin smlInterH1\r\n    color: black\r\n    font-size: 2rem\r\n    font-family: $InterFont\r\n    font-weight: 800\r\n    letter-spacing: -0.0525rem\r\n\r\n@mixin smlInterH2\r\n    color: black\r\n    font-size: 1.5rem\r\n    font-family: $InterFont\r\n    font-weight: 800\r\n    letter-spacing: -0.0225rem\r\n\r\n@mixin smlInterH3\r\n    color: black\r\n    font-size: 1.2rem\r\n    font-family: $InterFont\r\n    font-weight: 600\r\n    letter-spacing: 0.0025rem\r\n\r\n@mixin smlInterP\r\n    color: black\r\n    font-size: .9rem\r\n    font-family: $InterFont\r\n    letter-spacing: 0.0125rem\r\n\r\n@mixin transparentText\r\n    background-image: url('#{$assetsPath}/Flag-Yemen.webp')\r\n    background-size: 100% 100%\r\n    background-repeat: no-repeat\r\n    -webkit-background-clip: text\r\n    -webkit-text-fill-color: transparent\r\n\r\n@mixin transparentBg\r\n    background-image: url('#{$assetsPath}/Flag-Yemen.webp')\r\n    background-size: 100% 100%\r\n    background-blend-mode: color-burn\r\n    background-repeat: no-repeat\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
